module.exports = __webpack_public_path__ + "img/pc-success.e8fcdb1c.svg";